import {
    apiRequest,
    dependentCreate,
} from "../../../../../services/adapters/master/dependentService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", dependentCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository